import styled from '@emotion/styled'

export const StatisticsSection = styled.section`
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	border: 1px solid #e6ecf3;
`

export const StatisticsTitle = styled.h2`
	margin: 30px 0;
	padding: 0;
	font-size: 20px;
	text-transform: uppercase;
`

export const StatisticsList = styled.ul`
	display: flex;
	margin: 0;
	padding: 0;
	list-style: none;
`

